import type { API } from 'chessboard/api/config/types';
import { Core } from 'chessboard/core/config/types';
import type { Game } from 'chessboard/model/game/types';
import { DeprecationWarnings } from 'chessboard/api/config/deprecation-warnings';
import type { Markings } from 'chessboard/plugins/markings/config/types';

/**
 * Create the clearMarkings method.
 */
export function createClearMarkings(context: API.Context) {
  /**
   * Call the JCE clearMarkings method.
   */
  return function clearMarkings(
    types?: Game.Node.Marking.Types[],
    options: Markings.WhereOptions = {},
  ): API.Response {
    console.warn(DeprecationWarnings.ClearMarkings); // eslint-disable-line

    const { api, respond } = context;
    const markings = <Markings.API>api.markings;
    const mappedTypes = types?.map((type) => (type === 'square' ? 'highlight' : type));

    markings.removeAllWhere({ ...options, types: mappedTypes });

    return respond(Core.APIEvents.ClearMarkings);
  };
}
